"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHLQATaskViewWidget = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const dashboard_widget_1 = __importDefault(require("../dashboard-widget"));
exports.StyledHLQATaskViewWidget = (0, styled_components_1.default)(dashboard_widget_1.default) `
  grid-area: hlqa-task-view-widget;
  max-height: 45rem;
  overflow: hidden;

  .widget-content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .MuiDataGrid-root {
    min-height: 20rem;
  }

  .total-results {
    font-size: 0.875rem;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }

  .dashboard-hlqa-only & {
    max-height: none;
    min-height: 0;

    .widget-content {
      flex: 1 1 0;
      min-height: 0;
    }

    .MuiDataGrid-root {
      flex: 1 1 0;
      min-height: 0;
    }
  }
`;
